export default {
  bagFees: 'Der kan forekomme yderligere bagagegebyrer',
}
